import { Field, ObjectType } from 'type-graphql'
import { Task } from '../Task'

@ObjectType()
export class TaskSubTasksResult {
  @Field(() => [Task])
  subTasks: Task[]

  @Field(() => Task)
  task: Task
}
